import React from 'react';
import DataTable from '../../../common/data_display/DataTable';
import { formatDate, formatNumber } from '../../../common/data_display/utils';

export default function AdmInfoTable(props) {
  const { d0_date, d2_date, timestamp, predicted_defects_at_d0, overall_stability_score } = props;

  const rows = [
    { name: 'Report Date', value: timestamp ? formatDate(new Date(timestamp)) : undefined },
    { name: 'D0 Date', value: d0_date ? formatDate(new Date(d0_date)) : undefined },
    { name: 'D2 Date', value: d2_date ? formatDate(new Date(d2_date)) : undefined },
    { name: 'Target Defects @ D0', value: formatNumber(Math.round(predicted_defects_at_d0 * 10) / 10) },
  ];

  return <DataTable title='Info' rows={rows} />
}
